// HP-9369: GraphQL sends these amounts in dollars, and the delayed recalculation converts the
// carrier amount with dollarsToCents. On an invited carrier's assigned load the carrier amount is
// the carrier pay, so it stays in dollars; dividing it by 100 made "Your Pay" 100 times too small.
// The broker and carrier-own branches are unchanged.
export function getInitialCarrierInvoiceAmount(options: {
  isBroker: boolean;
  isAssignedLoadsPage: boolean;
  paymentProfileAmount?: number | null;
  displayAmount?: number | null;
  amount: number;
}): number {
  const { isBroker, isAssignedLoadsPage, paymentProfileAmount, displayAmount, amount } = options;

  if (isBroker) {
    return parseFloat(
      (isAssignedLoadsPage ? (paymentProfileAmount ?? 0) / 100 : paymentProfileAmount ?? 0).toFixed(
        2
      )
    );
  }

  if (isAssignedLoadsPage) {
    return parseFloat((paymentProfileAmount ?? 0).toFixed(2));
  }

  return (displayAmount || parseFloat(amount.toFixed(2))) / 100;
}
